import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { VehicleBusinessService } from '../../business-services/vehicle-service';


@Injectable({ providedIn: 'root' })
export class VehicleGuard  {

  constructor(
    private service: VehicleBusinessService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.service.vehicleId) {
      return true;
    }
    return this.router.createUrlTree(['/vehicle']);
  }
}
